import { createFileRoute, redirect } from '@tanstack/react-router'

import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_ROLE } from '@/libs/api/types'
import { setSentryDcId, setSentryTenantKey } from '@/libs/sentry/sentry-config'

export const Route = createFileRoute('/_protected/admin')({
  beforeLoad: ({ context: { auth } }) => {
    const authUser = auth.user

    if (
      !(
        authUser.userRole === USER_ROLE.ADMIN &&
        authUser.tenants.find((t) => ['simount', 'test-tenant'].includes(t.key))
      )
    ) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }

    // テナント配下を離れるので、直前のテナントと拠点を残さない (#5134)。
    // ここを通るのはテナント横断の管理画面で、どちらの値も意味を持たない。
    setSentryTenantKey(null)
    setSentryDcId(null)
  }
})
